<app-add-reference-card [desc]="noDataMessage" *ngIf="dataSource.data.length < 1">
</app-add-reference-card>
<div class="scrollmenu">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 data-grid-table"
    *ngIf="dataSource.data.length > 0">
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
      <th mat-header-cell *matHeaderCellDef>
        {{column.header}}
      </th>
      <td mat-cell *matCellDef="let row">
        <div *ngIf="(isString(column.cell(row)))" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough} ">
          {{column.cell(row)}}</div>
        <div *ngIf="!(isString(column.cell(row)))">
          <div [innerHTML]="(column.cell(row))"></div>
        </div>
        <div *ngIf="column.columnDef === 'view'" class="view" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough , 'view-pointer' : row.isDeleted === false && row.Strikethrough === false}" (click)="column.onClick ? column.onClick(row) : null"  >
          View
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<mat-paginator [hidden]="!paginatorRequired" [ngClass]="{'d-none': dataSource.data.length < 1}" [length]="dataSource.data.length" [pageSize]="5"
  [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons>
</mat-paginator>